import {
  Box,
  CardActionArea,
  Skeleton,
  Typography,
  useTheme,
} from '@mui/material'
import AddIcon from '@mui/icons-material/Add'

interface AddBidPlaceholderProps {
  onAdd: () => void
}

export default function AddBidPlaceholder({ onAdd }: AddBidPlaceholderProps) {
  const theme = useTheme()

  return (
    <CardActionArea
      onClick={onAdd}
      sx={{
        width: '100%',
        height: '100%',
        flexGrow: 1,
        minHeight: 240,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        border: '2px dashed',
        borderColor: theme.palette.primary.light,
        backgroundColor: theme.palette.primary.light + '20',
        borderRadius: 1,
        p: 2,
        cursor: 'pointer',
        boxShadow: '0 4px 8px rgba(0,0,0,0.05)',
        transition: 'all 0.3s ease-in-out',
        '&:hover': {
          borderColor: theme.palette.primary.light,
          backgroundColor: theme.palette.primary.light + '40',
          boxShadow: '0 6px 10px rgba(0,0,0,0.08)',
        },
        '&:hover .add-content': { opacity: 0 },
        '&:hover .skeleton': { opacity: 1 },
      }}
    >
      <Box
        className="add-content"
        sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
      >
        <AddIcon
          fontSize="large"
          sx={{ color: theme.palette.primary.main, mb: 1 }}
        />
        <Typography sx={{ color: theme.palette.primary.main, fontWeight: 600 }}>
          Add Bid
        </Typography>
      </Box>

      {/* Hover skeleton preview */}
      <Box
        className="skeleton"
        sx={{
          position: 'absolute',
          inset: 0,
          p: 2,
          opacity: 0,
          pointerEvents: 'none',
          pt: 6,
          transition: 'opacity 0.2s',
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
          bgcolor: 'rgba(255,255,255,0.8)',
        }}
      >
        <Skeleton variant="rounded" height={34} />
        <Skeleton variant="rounded" height={34} />
        <Skeleton variant="rounded" height={70} sx={{ mt: 1 }} />
      </Box>
    </CardActionArea>
  )
}
